module.exports = __webpack_public_path__ + "static/4_years-68fee8d695925949bd3b4510f6acd064.png";